import {translates} from "./translates/translates.cs";

export const t = (key: keyof typeof translates): string => translates[key] ?? '{' + key + '}';